export function RequestToBookViewedByHost() {
  return "The organiser has requested a quote to hold their event at your venue";
}

export function RequestToBookViewedByOrganiser({ thread }) {
  return `Quote requested. ${thread._venue.name} will share a quote with you shortly`;
}
